import QRCode from 'qrcode';
import type { UzPayConfig, PaymentQrResult } from './types';

/**
 * Генерация платёжного диплинка Click/Payme и векторного SVG QR-кода.
 * Переиспользует библиотеку qrcode (SVG — минимум нагрузки на CPU касс).
 */
export async function generateUzPaymentQr(
  config: UzPayConfig,
  amountUz: number,
  orderId: string
): Promise<PaymentQrResult> {
  let deepLink = '';

  if (config.provider === 'click') {
    // Спецификация диплинка Click.uz:
    // https://my.click.uz/services/pay?service_id=...&merchant_id=...&amount=...&transaction_param=...
    const params = new URLSearchParams({
      service_id: config.serviceId || '',
      merchant_id: config.merchantId,
      amount: String(amountUz),
      transaction_param: orderId,
    });
    deepLink = `https://my.click.uz/services/pay?${params.toString()}`;
  } else if (config.provider === 'payme') {
    // Спецификация Payme Checkout (Base64 параметров):
    // m=merchant_id;ac.order_id=orderId;a=amount_in_tiyin (сум * 100)
    const rawParams = `m=${config.merchantId};ac.order_id=${orderId};a=${amountUz * 100}`;
    const base64Params = btoa(rawParams);
    deepLink = `https://checkout.paycom.uz/${base64Params}`;
  }

  // Генерация чистого SVG QR-кода с брендовыми цветами провайдера.
  const qrSvg = await QRCode.toString(deepLink, {
    type: 'svg',
    margin: 1,
    color: {
      dark: config.provider === 'click' ? '#0073FF' : '#00CCCC',
      light: '#FFFFFF',
    },
  });

  return {
    provider: config.provider,
    deepLink,
    qrSvg,
  };
}
